import { attr } from '@ni/fast-element';
import {
    Button as FoundationButton,
    buttonTemplate as template,
    DesignSystem
} from '@ni/fast-foundation';
import { styles } from './styles';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-card-button': CardButton;
    }
}

/**
 * A nimble-styled card button
 */
export class CardButton extends FoundationButton {
    /**
     * @public
     * @remarks
     * HTML Attribute: selected
     */
    @attr({ mode: 'boolean' })
    public selected = false;
}

/**
 * A function that returns a nimble-card-button registration for configuring the component with a DesignSystem.
 * Implements {@link @ni/fast-foundation#buttonTemplate}
 *
 * @public
 * @remarks
 * Generates HTML Element: \<nimble-card-button\>
 *
 */
const nimbleCardButton = CardButton.compose({
    baseName: 'card-button',
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true
    }
});

DesignSystem.getOrCreate().withPrefix('nimble').register(nimbleCardButton());
export const cardButtonTag = 'nimble-card-button';
